// 引入cookie-js
import Cookie from 'js-cookie'

import Vue from 'vue'
import VueRouter from 'vue-router'

Vue.use(VueRouter)

const routes = [{
  path: '/',
  component: () => import('@/views/index.vue')
}, {
  path: '/manage/',
  component: () => import('@/views/manage/index.vue'),
  children: [{
      path: '/manage/',
      meta: {
        title: '国家电网数据',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/dataset/stategrid'], resolve)
    }, {
      path: '/manage/admin/lists',
      meta: {
        title: '管理人员',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/admin/lists'], resolve)
    },
    {
      path: '/manage/admin/group',
      meta: {
        title: '管理角色',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/admin/group'], resolve)
    },
    {
      path: '/manage/admin/menu',
      meta: {
        title: '管理权限',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/admin/menu'], resolve)
    }, {
      path: '/manage/dataset/stategrid',
      meta: {
        title: '国家电网数据',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/dataset/stategrid'], resolve)
    },
    {
      path: '/manage/dataset/gefcom',
      meta: {
        title: 'GEFCom数据',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/dataset/gefcom'], resolve)
    },
    {
      path: '/manage/point/lists',
      meta: {
        title: '站点管理',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/point/lists'], resolve)
    },
    {
      path: '/manage/dataset/echarts',
      meta: {
        title: '模型图表',
        requireAuth: true
      },
      component: resolve => require(['@/views/manage/dataset/echarts'], resolve)
    },
  ]
}]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
})

// 导航守卫
router.beforeEach((to, from, next) => {
  if (to.meta.requireAuth == true) { // 判断该路由是否需要登录权限
    let admin = Cookie.get('admin')
    if (admin === undefined || admin === 'e30=' || !admin) { // cookie是否存在
      next({
        path: '/' // 跳转到登录界面
      })
    } else {
      next()
    }
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js